import * as React from "react";

function PropertyIcon(props) {
  return (
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.5 18.2009H1.5C1.23478 18.2009 0.98043 18.0956 0.792893 17.908C0.605357 17.7205 0.5 17.4661 0.5 17.2009V9.68793C0.499984 9.54504 0.530591 9.40381 0.589758 9.27374C0.648924 9.14368 0.735277 9.02781 0.843 8.93393L4.5 5.74493V1.20093C4.5 0.935711 4.60536 0.681357 4.79289 0.493821C4.98043 0.306285 5.23478 0.200928 5.5 0.200928H19.5C19.7652 0.200928 20.0196 0.306285 20.2071 0.493821C20.3946 0.681357 20.5 0.935711 20.5 1.20093V17.2009C20.5 17.4661 20.3946 17.7205 20.2071 17.908C20.0196 18.0956 19.7652 18.2009 19.5 18.2009ZM7.5 16.2009H10.5V10.1429L6.5 6.65493L2.5 10.1429V16.2009H5.5V12.2009H7.5V16.2009ZM12.5 16.2009H18.5V2.20093H6.5V4.32793C6.734 4.32793 6.969 4.40993 7.157 4.57493L12.157 8.93393C12.2647 9.02781 12.3511 9.14368 12.4102 9.27374C12.4694 9.40381 12.5 9.54504 12.5 9.68793V16.2009ZM14.5 8.20093H16.5V10.2009H14.5V8.20093ZM14.5 12.2009H16.5V14.2009H14.5V12.2009ZM14.5 4.20093H16.5V6.20093H14.5V4.20093ZM10.5 4.20093H12.5V6.20093H10.5V4.20093Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoPropertyIcon = React.memo(PropertyIcon);
export default MemoPropertyIcon;
